import axios from 'axios';
import { logger } from '../utils/logger';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class AuthService {
  private token: string | null = null;

  async authenticate(initData: string) {
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/telegram`, {
        initData
      });

      this.token = response.data.token;
      // Store in localStorage for easy access
      if (this.token) {
        localStorage.setItem('authToken', this.token);
      }
      return response.data;
    } catch (error) {
      logger.error('Authentication failed:', error);
      throw error;
    }
  }

  getToken() {
    return this.token;
  }

  setToken(token: string) {
    this.token = token;
    // Also store in localStorage for easy access
    if (token) {
      localStorage.setItem('authToken', token);
    }
  }

  // Helper to get token from localStorage
  getStoredToken() {
    return localStorage.getItem('authToken');
  }

  getAuthHeaders() {
    return {
      'Authorization': `Bearer ${this.token}`,
      'Content-Type': 'application/json'
    };
  }

  async getCurrentUser() {
    try {
      const response = await axios.get(`${API_BASE_URL}/auth/me`, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      logger.error('Failed to get current user:', error);
      throw error;
    }
  }
}

export const authService = new AuthService();
